<div class="panneau-correspondances-patients__container">
	<div class="container__content">
		<di-donnees-patient-cv *ngIf="patientCV" [patient]="patientCV"></di-donnees-patient-cv>
		<div class="container_subtitle">
			<h2>J'ai un doute !</h2>
			<p>{{correspondancesPatient.length}} dossier{{correspondancesPatient.length > 0 ? 's' : ''}} avec une correspondance <strong>sur le numéro de sécurité sociale, le nom de naissance, le prénom ou la date de naissance.</strong></p>
		</div>
		<div class="container_dossier_patient">
			<di-dossier-patient *ngFor="let correspondance of correspondancesPatient"
				[patient]="correspondance"
				[selected]="correspondance._id === selectedPatient?._id"
				(select)="onSelectPatient($event)">
			</di-dossier-patient>
		</div>
		<div class="container_buttons">
			<lua-action-principale [fullWidth]="true" libelle="Choisir ce dossier" endIcon="arrow_right_alt" (click)="selectCorrespondance()" [isDisabled]="!selectedPatient"></lua-action-principale>
			<lua-action-secondaire [fullWidth]="true" size="large" libelle="Créer un nouveau dossier" (click)="onCreatePatient(patientCV)"></lua-action-secondaire>
		</div>
	</div>
</div>
